
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">


           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.name}}
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            举办时间 {{record.startdate}}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">

        开始报名 {{record.stime|timeFormat}}
        <br/>
        结束报名 {{record.etime|timeFormat}}
        <br/>



        <a-tag v-if="record.status==1" color="green">进行中</a-tag>
        <a-tag v-else>未进行</a-tag>
        <a-tag v-if="record.type==1" color="green">显示</a-tag>
        <a-tag v-else>不显示</a-tag>


      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
        </template>
      </span>
    </s-table>



    <a-modal
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="名称"
                      hasFeedback
                >
                <a-input :disabled="formData.id>0"  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入名称' }]}
            ]"
                          placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">

              </a-col>
            </a-row>
            <a-row :gutter="48">

              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="是否进行"
                        hasFeedback
                >
                  <r-switch  :formData="formData" field="status" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
                </a-form-item>
              </a-col>
            </a-row>


            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="是否显示"
                        hasFeedback
                >
                  <r-switch  :formData="formData" field="type" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="activity编号"
                        extra="问卷星的试卷编号"
                        hasFeedback
                >
                  <a-input type="number"  v-decorator="[
          'activity_id',
          {rules: [ ]}
        ]"
                           placeholder="请输入问卷星试卷编号"/>
                </a-form-item>
              </a-col>

            </a-row>


            <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="日期"
                      hasFeedback
              >
                <a-range-picker
                        v-model="formData.date_range_moment"
                        format="YYYY-MM-DD"
                />
              </a-form-item>

              </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="报名时间"
                      hasFeedback
              >
                <a-range-picker
                        v-model="formData.time_range_moment"
                        :showTime="{
        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
      }"
                        format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>

              </a-col>
            </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="类型"
                      hasFeedback
              >

                <a-select v-model="formData.class_type" placeholder="请选择"
                          allowClear >
                  <a-select-option value="C">C级班</a-select-option>
                  <a-select-option value="B">B级班</a-select-option>
                  <a-select-option value="A">A级班</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="报名费用"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'price',
              {rules: [{ required: true, message: '报名费用' }]}
            ]"
                         placeholder="请输入报名费用"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48" >
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="监督考试编号"
                      extra="问卷星的试卷编号"
                      hasFeedback
              >
                <a-input type="number"  v-decorator="[
          'activity_id2',
          {rules: [ ]}
        ]"
                         placeholder="请输入问卷星试卷编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="课程ID"
                      extra="啦啦操之星小程序课程ID"
                      hasFeedback
              >
                <a-input type="number"  v-decorator="[
          'video_id',
          {rules: [ ]}
        ]"
                         placeholder="请输入啦啦操之星小程序课程ID"/>
              </a-form-item>
            </a-col>
          </a-row>




          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="报名咨询二维码"
                      extra="扫码加工作人员好友，提交考试视频"
                      hasFeedback
              >
                <pic-uploader
                        :numberLimit="1"
                        :file-list="formData.erweiimg"
                />
              </a-form-item>
            </a-col>
          </a-row>






        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>




    <a-modal
            title="服务套餐设置"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="serviceTypeVisible"
            @ok="serviceTypeVisible=false"
    >
      <a-spin :spinning="saveLoading">
          <a-table
                  :columns="serviceTypeColumns"
                  :dataSource="serviceTypeList"
                  :pagination="false"
                  rowKey="id"
                  :scroll="{ y: 300 }"
                  bordered
          >

        <span slot="show" slot-scope="text,record">
          <a-tag v-if="record.show==1" color="green">显示</a-tag>
          <a-tag v-else>隐藏</a-tag>
        </span>
        <span slot="loc" slot-scope="text,record">
          <a-tag v-if="record.loc==1" color="green">是</a-tag>
          <a-tag v-else>否</a-tag>
        </span>

            <template slot="action" slot-scope="text,record,index">
              <a href="javascript:;" @click="onEditServiceType(record)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm
                      title="确定删除此套餐吗"
                      @confirm="deleteServiceType(record,index)"
                      okText="确定"
                      cancelText="取消"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <a-button icon="plus" @click="onAddServiceType">新增</a-button>
            </template>
          </a-table>
      </a-spin>
    </a-modal>

    <a-modal
            title="套餐操作"
            :width="1000"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="serviceTypeFormVisible"
            @ok="handleServiceTypeOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="名称"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入套餐名称' }]}
            ]"
                         placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="说明"
                      hasFeedback
              >
                <a-textarea    v-decorator="[
              'note',
              {rules: [ ]}
            ]"
                         placeholder="请输入说明"/>
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="单价"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'price',
              {rules: [{ required: true, message: '请输入单价' }]}
            ]"
                          placeholder="请输入单价"/>
              </a-form-item>
            </a-col>

          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="仅限本地购买"
                      hasFeedback
              >
                <r-switch  :formData="serviceTypeFormData" field="loc" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="是否显示"
                      hasFeedback
              >
                <r-switch  :formData="serviceTypeFormData" field="show" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>


          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleServiceTypeCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleServiceTypeOk">保存</a-button>
      </template>
    </a-modal>


  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import RSwitch from '@/components/RSwitch/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getSaiquList ,getSaiquDetail,editSaiqu,addSaiqu,getSaijiList,getServiceTypeList,serviceTypeDelete,getServiceTypeDetail,editServiceType,addServiceType  } from '@/api/cba'
  export default {
    name: 'CbaSaiquList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        saveLoading:false,
        shenbaoOptions : [
          {'label':'裁判等级（舞蹈）','value':'caipandengjiwudao'},{'label':'裁判等级（技巧）','value':'caipandengjijiqiao'},{'label':'教练等级（舞蹈）','value':'jiaoliandengjiwudao'},{'label':'教练等级（技巧）','value':'jiaoliandengjijiqiao'}
        ],
        gjsbOptions : [
          {'label':'高级裁判员资质申请','value':'caipan'},{'label':'高级教练员资质申请','value':'jiaolian'}
        ],
        formData:{
          id:0,
          status:1,
          type:1,
          danwei:'',
          saidate_moment:null,
          saidate:'',
          time_range_moment:[],
          time_range:[],
          date_range_moment:[],
          date_range:[],
          erweiimg:[],
          areas:[],
          shenbaotype:[],
          erweiimg:[],
          gjsbshow:[],
          pic:[],
          pics:[],
        },
        saijiOptions:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        form2: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 150,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;


          this.queryParam = Object.assign(this.queryParam,parameter);
          return getSaiquList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],

        //表头
        serviceTypeColumns: [
          {
            title: '名称',
            dataIndex: 'name',
          },
          {
            title: '价格',
            width: '150px',
            dataIndex: 'price',
          },
          {
            title: '仅限本地',
            width: '150px',
            dataIndex: 'loc',
            scopedSlots: { customRender: 'loc' },
          },
          {
            title: '显示',
            dataIndex: 'show',
            width: '150px',
            scopedSlots: { customRender: 'show' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 150,
            scopedSlots: { customRender: 'action' },
          },
        ],
        serviceTypeQuery: {
          saiqu: 0,
        },
        serviceTypeVisible:false,
        serviceTypeFormVisible:false,
        serviceTypeList: [],
        serviceTypeFormData:{
          id:0,
          name:'',
          loc:1,
          show:1,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
    },
    methods: {
      moment,
      addHandle(){
        this.formData = {
          id:0,
          status:1,
          type:1,
          danwei:'',
          saidate_moment:null,
          saidate:'',
          time_range_moment:[],
          time_range:[],
          date_range_moment:[],
          date_range:[],
          erweiimg:[],
          areas:[],
          erweiimg:[],
          class_type:[],
          price:'',
          pic:[],
          pics:[],
        },
        this.form.resetFields();
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      },
      handleServiceTypeCancel(){
        this.serviceTypeFormVisible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getSaiquDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            res.data.time_range_moment = [moment(res.data.stime*1000),moment(res.data.etime*1000)];
            res.data.date_range_moment = [moment(res.data.startdate,'YYYY-MM-DD'),moment(res.data.enddate,'YYYY-MM-DD')];
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        if(self.formData.time_range_moment.length!=2){
          self.$message.error('请选择时间范围');
          return ;
        }
//        if(self.formData.areas.length!=3){
//          self.$message.error('请选择完整地区');
//          return ;
//        }
        if(self.formData.class_type ==''){
          self.$message.error('请选择类型');
          return ;
        }
        if(self.formData.date_range_moment.length!=2){
          self.$message.error('请选择日期');
          return ;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id>0){

                editSaiqu({
                  id:self.formData.id,
                  name:values.name,
                  status:self.formData.status,
                  type:self.formData.type,
                  //area:self.formData.areas[self.formData.areas.length-1],
                  time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],
                  date_range:[self.formData.date_range_moment[0].format('YYYY-MM-DD'),self.formData.date_range_moment[1].format('YYYY-MM-DD')],
                  fapiaomingxi:values.fapiaomingxi,
                  erweiimg:self.formData.erweiimg,
                  class_type:self.formData.class_type,
                  price:values.price,
                  activity_id:values.activity_id,
                  activity_id2:values.activity_id2,
                  video_id:values.video_id,
                  pic:self.formData.pic,
                  pics:self.formData.pics,
                  gjsbshow:self.formData.gjsbshow,
                  shenbaotype:self.formData.shenbaotype,
                }).then(res => {
                  self.$message.success('修改成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                  self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
                addSaiqu({
                  name:values.name,
                  saiji:self.formData.saiji,
                  status:self.formData.status,
                  type:self.formData.type,
                  //area:self.formData.areas[self.formData.areas.length-1],
                  time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],
                  date_range:[self.formData.date_range_moment[0].format('YYYY-MM-DD'),self.formData.date_range_moment[1].format('YYYY-MM-DD')],
                  fapiaomingxi:values.fapiaomingxi,
                  erweiimg:self.formData.erweiimg,
                  class_type:self.formData.class_type,
                  price:values.price,
                  activity_id:values.activity_id,
                  activity_id2:values.activity_id2,
                  pic:self.formData.pic,
                  pics:self.formData.pics,
                  gjsbshow:self.formData.gjsbshow,
                  shenbaotype:self.formData.shenbaotype,
                }).then(res => {
                  self.$message.success('新增成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                  self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }

          }
        })
      },
      onAddServiceType(){
        this.serviceTypeFormData = {
          id:0,
          name:'',
          loc:1,
          show:1,
        },
        this.form2.resetFields();
        this.serviceTypeFormVisible = true
      },
      onEditServiceType(record){
        let self = this
        this.serviceTypeFormVisible = true
        getServiceTypeDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form2.setFieldsValue({ ...res.data })
            self.serviceTypeFormData.id = record.id;
            self.serviceTypeFormData = { ...res.data };
          },200)
        })
      },
      deleteServiceType(record){
        let self = this;
        serviceTypeDelete({ id: record.id }).then(res =>{
          self.fetchServiceTypeList();
        })
      },
      handleServiceType(record){
        let self = this
        self.fetchServiceTypeList()
        self.serviceTypeQuery.saiqu = record.id;
        self.serviceTypeVisible = true
      },

      fetchServiceTypeList() {
        let self = this
        getServiceTypeList(self.serviceTypeQuery).then(res => {
          self.serviceTypeList = res.data
        })
      },


      // 增改 处理
      handleServiceTypeOk(e) {
        let self = this;
        e.preventDefault()
        this.form2.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.serviceTypeFormData)
            self.saveLoading = true;
            if(self.serviceTypeFormData.id>0){
              editServiceType({
                id:self.serviceTypeFormData.id,
                name:values.name,
                price:values.price,
                note:values.note,
                loc:self.serviceTypeFormData.loc,
                show:self.serviceTypeFormData.show,
              }).then(res => {
                self.$message.success('修改成功')

                self.fetchServiceTypeList();

                self.serviceTypeFormVisible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addServiceType({
                name:values.name,
                price:values.price,
                note:values.note,
                saiqu:self.serviceTypeQuery.saiqu,
                loc:self.serviceTypeFormData.loc,
                show:self.serviceTypeFormData.show,
              }).then(res => {
                self.$message.success('新增成功')
                self.fetchServiceTypeList();


                self.serviceTypeFormVisible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }

          }
        })
      },



      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
